// extracted by mini-css-extract-plugin
export var button = "g_5";
export var input = "g_3";
export var readerPage = "g_2";
export var textarea = "g_4";